/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {FindEmployeeRolesRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {FindEmployeeRolesResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const findEmployeeRoles = (request: FindEmployeeRolesRequest, options?: CashRequestOptions) => post<FindEmployeeRolesRequest, FindEmployeeRolesResponse>("/2.0/cash/find-employee-roles", request, {...options, rejectOnError: true })